import React from 'react';  // eslint-disable-line

const Grabber = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 50"><path d="M15,32h2v2H15Zm-4,0h2v2H11Zm4,4h2v2H15Zm-4,0h2v2H11Zm0-12h2v2H11Zm4,4h2v2H15Zm-4,0h2v2H11Zm4-4h2v2H15Zm0-4h2v2H15Zm-4,0h2v2H11Zm4-4h2v2H15Zm-4,0h2v2H11Zm4-4h2v2H15Zm-4,0h2v2H11Z" fill="#232323" /></svg>
    );
};

export default Grabber;
